export default "__VITE_ASSET__CQyNrLXA__"